import { useSideCategoryMenuStore } from "@/components/SideSheets/store/useCategoryMenuStore";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import useGetCategoryMenu from "../queries/useGetCategoryMenu";
export const useCategoryMenu = ()=>{
    const router = useRouter();
    const { isOpenSideMenu , closeSideMenu  } = useSideCategoryMenuStore();
    const { homeType  } = useHomeSwitchStore();
    // 카테고리 메뉴 데이터 (React Query)
    const { data: menuData , isLoading , isError  } = useGetCategoryMenu();
    // 선택된 메뉴(과목) ID - 데이터 로드 후 첫 번째 메뉴로 초기화
    const [selectedMenuId, setSelectedMenuId] = useState(null);
    // homeType 변경 감지를 위한 ref
    const prevHomeTypeRef = useRef(homeType);
    // homeType 변경 시 selectedMenuId 리셋
    useEffect(()=>{
        if (prevHomeTypeRef.current !== homeType) {
            setSelectedMenuId(null);
            prevHomeTypeRef.current = homeType;
        }
    }, [
        homeType
    ]);
    // 데이터 로드 시 첫 번째 메뉴로 설정
    useEffect(()=>{
        var _menuData_menus;
        if ((menuData === null || menuData === void 0 ? void 0 : (_menuData_menus = menuData.menus) === null || _menuData_menus === void 0 ? void 0 : _menuData_menus.length) && selectedMenuId === null) {
            setSelectedMenuId(menuData.menus[0].id);
        }
    }, [
        menuData,
        selectedMenuId
    ]);
    // 메뉴(과목) 리스트 (1depth)
    const menus = useMemo(()=>{
        var _menuData_menus;
        return (_menuData_menus = menuData === null || menuData === void 0 ? void 0 : menuData.menus) !== null && _menuData_menus !== void 0 ? _menuData_menus : [];
    }, [
        menuData
    ]);
    // 선택된 메뉴(과목) 정보
    const selectedMenu = useMemo(()=>{
        if (!menuData) return null;
        return menuData.menus.find((menu)=>menu.id === selectedMenuId) || menuData.menus[0];
    }, [
        menuData,
        selectedMenuId
    ]);
    // 카테고리 컬럼 (sections 배열)
    const categoryColumns = useMemo(()=>{
        if (!selectedMenu) return [];
        return selectedMenu.sections;
    }, [
        selectedMenu
    ]);
    // 과목 클릭 핸들러
    const handleSubjectClick = (item)=>{
        setSelectedMenuId(item.id);
    };
    // 카테고리 아이템 클릭 핸들러 (카테고리 페이지로 이동)
    const handleItemClick = useCallback((item)=>{
        closeSideMenu();
        router.push(item.itemLink);
    }, [
        closeSideMenu,
        router
    ]);
    // 메뉴 닫기
    const handleClose = useCallback(()=>{
        closeSideMenu();
    }, [
        closeSideMenu
    ]);
    var _selectedMenu_menuFooter;
    return {
        // 상태
        isOpen: isOpenSideMenu,
        selectedMenuId,
        isLoading,
        isError,
        // 데이터
        menus,
        selectedMenu,
        categoryColumns,
        menuFooter: (_selectedMenu_menuFooter = selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.menuFooter) !== null && _selectedMenu_menuFooter !== void 0 ? _selectedMenu_menuFooter : [],
        // 핸들러
        handleSubjectClick,
        handleItemClick,
        handleClose
    };
};
